import React, { useState, useRef, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { apiUrl, brands } from "../../../config/config";

const SearchBar = ({ mobile = false }) => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [searched, setSearched] = useState(false);
  const navigate = useNavigate();
  const containerRef = useRef(null);

  // --------------------------
  // CLOSE DROPDOWN ON OUTSIDE CLICK
  // --------------------------
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setResults([]);
        setSearched(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "";

    if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
      return imagePath;
    }

    if (imagePath.startsWith("/storage/")) {
      return `${apiUrl}${imagePath}`;
    }

    if (imagePath.startsWith("storage/")) {
      return `${apiUrl}/${imagePath}`;
    }

    return `${apiUrl}/storage/${imagePath}`;
  };

  const handleSearch = async (value) => {
    setQuery(value);

    if (value.trim().length < 2) {
      setResults([]);
      setSearched(false);
      return;
    }

    try {
      const res = await fetch(
        `${apiUrl}/api/${brands}/products/search?query=${value}`
      );
      const data = await res.json();

      setSearched(true);

      if (data.data && data.data.length > 0) {
        setResults(data.data);
      } else {
        setResults([]);
      }
    } catch (err) {
      console.log("Search error:", err);
    }
  };

  const selectProduct = (product) => {
    navigate(
      `/product/${product.category.category_name.replace(/\s+/g, "-")}/${
        product.category_id
      }/${product.name.replace(/\s+/g, "-")}/${product.id}`
    );

    setResults([]);
    setQuery("");
    setSearched(false);
  };

  return (
    <div
      ref={containerRef}
      className={`relative w-full ${mobile ? "" : "max-w-xl"}`}
    >
      <div className="flex w-full items-center rounded-full border border-[#1e242a]/15 bg-white px-4 py-2.5 shadow-sm transition-all duration-300 focus-within:border-[#37404a] focus-within:ring-2 focus-within:ring-[#37404a]/20">
        <input
          type="text"
          placeholder="Search products..."
          value={query}
          onChange={(e) => handleSearch(e.target.value)}
          className="flex-1 bg-transparent text-sm font-medium text-[#1e242a] outline-none placeholder:text-[#5f6870]"
        />

        <span className="ml-3 flex h-8 w-8 items-center justify-center rounded-full bg-[#e5e8e6] text-[#1e242a]">
          <FaSearch className="text-sm" />
        </span>
      </div>

      {(results.length > 0 || searched) && query.length >= 2 && (
        <div className="absolute left-0 z-50 mt-3 max-h-80 w-full overflow-y-auto rounded-2xl border border-[#1e242a]/10 bg-white shadow-[0_20px_55px_rgba(30,36,42,0.18)]">
          {results.length > 0 ? (
            results.map((item) => (
              <div
                key={item.id}
                className="flex cursor-pointer items-center gap-3 border-b border-[#1e242a]/5 p-3 transition-all duration-300 last:border-b-0 hover:bg-[#f5f6f5]"
                onClick={() => selectProduct(item)}
              >
                <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center overflow-hidden rounded-xl bg-[#e5e8e6]">
                  <img
                    src={getImageUrl(item.image)}
                    className="h-10 w-10 object-contain"
                    alt=""
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                    }}
                  />
                </div>

                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-bold text-[#1e242a]">
                    {item.name}
                  </p>

                  <p className="mt-0.5 truncate text-xs font-medium text-[#5f6870]">
                    {item.category?.category_name}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <div className="p-5 text-center text-sm font-medium text-[#5f6870]">
              No products found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchBar;